import React, { useCallback, useEffect, useState } from "react"
import {
    AlertType, Conta, ContasSearchBox, LanctoContaPag, ParamsLiqLanctoCartao, classBorderLabelDark, classBt, classInput, classInputDark, classLabel,
    classLabelDark, classbtAzul, classbtColunasVermelho, classbtVerde, classbtVermelho
} from "../../Utils/Types"
import { Funcoes } from "../../Utils/Funcoes"
import { SearchBox } from "../SearchBox/SearchBox"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { FaPlus, FaTrashAlt } from "react-icons/fa"
import moment from "moment"
import { HiDocumentCheck } from "react-icons/hi2"
import { ContaService } from "../../Pages/Contas/ContasService"
import { LanctoCartaoService } from "../../Pages/LancamentoCartao/LanctoCartaoService"

export type Props = {
    visible: boolean,
    totSelecionado: number,
    handleModalClose: () => void,
    handleConfirm: () => Promise<boolean>,
    lanctoCartaoSelectedList: number[],
}

export const ModalLiqLancamentoCartao = React.memo(({ visible, handleModalClose, handleConfirm, lanctoCartaoSelectedList, totSelecionado }: Props) => {

    let date = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK ---------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [visibleMsg, setVisibleMsg] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS  -----------------------------------------------------
    const [valor_baixa, setValor_Baixa] = useState("0.00")
    const [valor_restante_original, setValor_Restante_Origianl] = useState("0.00")
    const [valor_restante, setValor_Restante] = useState("0.00")
    const [dataBaixa, setDataBaixa] = useState(date)
    const [senha_usuario, setSenhaUsuario] = useState("")
    const [observacao, setObservacao] = useState("")

    // --------------- ATRIBUTOS LANCAMENTO CONTAS ----------------------------
    const [lanctoContasList, setLanctoContasList] = useState<LanctoContaPag[]>([])
    const [idConta, setIdConta] = useState<number>(0)
    const [contas, setContas] = useState<ContasSearchBox[]>([])
    const [contasList, setContasList] = useState<ContasSearchBox[]>([])
    const [descConta, setDescConta] = useState("")
    const [valorConta, setValorConta] = useState("0.00")

    // ------------------- SEARCH BOX ---------------------------------------------------------
    const [visibleSearchBoxContas, setVisibleSearchBoxContas] = useState<boolean>(false)

    //------------------------------------------------------------------- ATRIBUTOS E EFFECT ------------------------------------------------------------------------||
    const getAttributes = async () => {

        setVisibleMsg(false)
        setLoading(true)

        try {

            const Attributes = await ContaService.GetListConta()
            setContasList(Attributes.data)

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os dados`)

        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {

        if (visible) {

            setLanctoContasList([])
            setValor_Baixa(Funcoes.numberFormat(totSelecionado || '0', 'decimal', 2, 2))
            setValor_Restante_Origianl(Funcoes.numberFormat(totSelecionado || '0', 'decimal', 2, 2))

            getAttributes()

            let modal = document.getElementById('modal_liq_lanc_cartao')
            let modalContent = document.getElementById('modal_content_liq_lanc_cartao')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_liq_lanc_cartao');
            let modalContent = document.getElementById('modal_content_liq_lanc_cartao');

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]');
                    modalContent.classList.remove('mt-24');
                }
            }

            setVisibleSearchBoxContas(false)
        }

    }, [visible])

    useEffect(() => {
        // soma total da lista
        const valorLista = lanctoContasList.reduce((acc, item) => acc + Number(item.valor || 0), 0);

        // valor restante original (convertido corretamente para número)
        const valorOriginal = parseFloat(valor_restante_original.replaceAll(".", "").replace(",", ".")) || 0;

        // valor restante atualizado
        const valorRestante = valorOriginal - valorLista;

        // seta no state já formatado
        setValor_Restante(Funcoes.numberFormat(valorRestante, 'decimal', 2, 2));

    }, [lanctoContasList]); // dependência é a lista inteira, não só o length

    const handleInputFocus = () => {
        setVisibleSearchBoxContas(false)
    }

    //--------------------------------------------------------------------------------------------- INPUTS ------------------------------------------------------------------------------------------//
    const handleChangeValorBaixa = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor_Baixa(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeDataPagto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataBaixa(e.target.value)
    }

    const handleChangeSenhaUsuario = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSenhaUsuario(e.target.value)
    }

    const handleChangeObservacao = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    //--------------------------------------------------------------------------------------------- CONTAS ------------------------------------------------------------------------------------------//
    const handleClearContaClick = useCallback(() => {

        setIdConta(0)
        setVisibleSearchBoxContas(false)

    }, [contasList])

    const handleContaSelected = useCallback((conta: ContasSearchBox) => {

        if (conta) {

            setIdConta(conta.id)
            setDescConta(conta.description)
        }

        setVisibleSearchBoxContas(false)

    }, [contasList])

    const handleFilterContaClick = useCallback((description: string) => {

        if (description === "") {

            const newContas = [...contasList]
            setContas(newContas)

        } else {

            const newContas = [...contasList || []].filter((conta) => {
                return conta.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setContas(newContas || [])
        }
    }, [contasList])

    const handleChangeValorConta = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorConta(Funcoes.MaskMoney(e.target.value))
    }

    const handleAddContaListClick = () => {

        setVisibleMsg(false)

        let newLanctoContasList = lanctoContasList.filter(it => it.id_conta === idConta)

        if (parseFloat(valorConta) <= 0 || isNaN(parseFloat(valorConta))) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Valor da conta inválido")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (idConta === 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Conta não informada")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (newLanctoContasList.length > 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Conta já lançada")
                clearTimeout(timer)
            }, 250)
            return
        }

        const lanctoConta: LanctoContaPag = {
            id_conta: idConta,
            description: descConta,
            valor: parseFloat(valorConta)
        };

        // cria um novo array em vez de mutar
        setLanctoContasList(prev => [...prev, lanctoConta]);

        setIdConta(0)
        setDescConta("")
        setValorConta("0.00")
    }

    const handleRemoveContaListClick = (item: LanctoContaPag) => {
        setLanctoContasList(prev => prev.filter(it => it.id_conta !== item.id_conta));
    }

    const clickSearchBoxContas = useCallback(() => {
        setVisibleSearchBoxContas((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o search box do GrupoDesp e foca no Contas
                //setVisibleSearchBoxGrupoDesp(false)
                inputFocusContas()
            }
            return newState
        })
    }, [])

    const inputFocusContas = () => {
        let inputSearch = document.getElementById(`inputSearchBox-contas`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //---------------------------------------------------------------------------------------------  LIQUIDAR DUPLICATAS RECEBER ------------------------------------------------------------------------------------------//
    const handleLiquidarCartao = async () => {

        setVisibleMsg(false)
        setLoading(true)

        try {

            const parametros: ParamsLiqLanctoCartao = {
                data_baixa: '',
                observacao: '',
                vl_bruto: 0,
                vl_pagar: 0,
                senha_usuario: '',
                lanctoCartao: [],
                lanctoContasList: lanctoContasList,
            }

            let valorBaixar = lanctoContasList.reduce((acc, item) => acc + item.valor, 0);

            parametros.data_baixa = dataBaixa
            parametros.observacao = observacao
            parametros.vl_bruto = totSelecionado
            parametros.vl_pagar = valorBaixar
            parametros.senha_usuario = senha_usuario
            parametros.lanctoCartao = lanctoCartaoSelectedList

            //console.log("parametros: ", parametros)

            const retAPI = await LanctoCartaoService.Liquidar(parametros)

            if (retAPI.error) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage(retAPI.msg || '')
                    clearTimeout(timer)
                }, 250)

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Lançamento(s) liquidado(s) com sucesso")

                const dados = await handleConfirm()

                if (dados) {
                    const aguarde = setTimeout(() => {
                        clearFields()
                        handleModalClose()
                        clearTimeout(aguarde)
                    }, 250)
                }
            }


        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Não foi possível baixar o(s) lançamento(s). Por favor, tente novamente")

        } finally {
            setLoading(false)
        }

    }

    const clearFields = () => {
        setSenhaUsuario('')
        setValor_Baixa("0,00")
        setIdConta(0)
        setValorConta('')
        setDescConta('')
        setLanctoContasList([])
        setObservacao('')
    }

    const fecharModal = () => {

        if (messageType === 'DANGER') {
            setVisibleMsg(false)
        }

        setValor_Baixa("0.00")
        setDataBaixa(date)
        setSenhaUsuario("")
        setObservacao("")
        setIdConta(0)
        setValorConta('')
        setDescConta('')
        setLanctoContasList([])

        handleModalClose()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    return (

        <div id="modal_liq_lanc_cartao" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 bg-white`}>

            <div id="modal_content_liq_lanc_cartao" className={`relative flex flex-col w-[95%] md:w-[80%] xl:w-[60%] h-[510px] bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <HiDocumentCheck size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Baixar Lançamento de Cartão</span>
                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full`}>

                    <div className={`grid grid-cols-12 gap-3 bg-white dark:bg-slate-600 py-3 h-full overflow-y-auto px-2`}>

                        <div className={`col-span-12 md:col-span-5`}>

                            <div className={`grid grid-cols-12 gap-3`}>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id='total_baixa_lanc_cartao' type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_baixa} readOnly />
                                    <label htmlFor="total_baixa_lanc_cartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor a Baixar (R$)</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id='total_restante_lanc_cartao' type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_restante} readOnly />
                                    <label htmlFor="total_restante_lanc_cartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor Restante (R$)</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id='data_pagto_lanc_cartao' className={`${classInput} ${classInputDark} ${dataBaixa === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31"  disabled={true} value={dataBaixa} onFocus={handleInputFocus} onChange={handleChangeDataPagto} />
                                    <label htmlFor="data_pagto_lanc_cartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data da Baixa</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id='senha_usuario_lanc_cartao' className={`${classInput} ${classInputDark}`} type='password' inputMode="text" placeholder=' ' autoComplete="off" value={senha_usuario} onFocus={handleInputFocus} onChange={handleChangeSenhaUsuario} />
                                    <label htmlFor="senha_usuario_lanc_cartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Senha do Usuário</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <textarea id='observacao_lanc_cartao' className={`${classInput} ${classInputDark}  h-[80px] resize-none`} placeholder=' ' autoComplete="off" value={observacao} onFocus={handleInputFocus} onChange={handleChangeObservacao} />
                                    <label htmlFor="observacao_lanc_cartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                </div>

                            </div>

                        </div>

                        <div className={`col-span-12 md:col-span-7 h-[500px] sm:h-[350px] border border-slate-400 dark:border-slate-700 rounded-sm px-2`}>

                            <div className={`grid grid-cols-12 gap-3 mt-3 space-y-1 md:space-y-0`}>

                                <div className={`relative col-span-12 md:col-span-6 lg:col-span-6`}>
                                    <SearchBox
                                        dataList={contas}
                                        idRegistro={idConta}
                                        label="Conta"
                                        componentId="contas"
                                        visibleTAB={visibleSearchBoxContas}
                                        setDataClick={handleContaSelected}
                                        clearDataClick={handleClearContaClick}
                                        filterDataClick={handleFilterContaClick}
                                        clicado={clickSearchBoxContas}
                                    />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-9 md:col-span-4 lg:col-span-4`}>
                                    <input id='valor_conta' className={`${classInput} ${classInputDark}`} type='text' inputMode="numeric" placeholder=' ' autoComplete="off" value={valorConta} onFocus={handleInputFocus} onChange={handleChangeValorConta} />
                                    <label htmlFor="valor_conta" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-3 md:col-span-2 lg:col-span-2`}>
                                    <button className={` ${classBt} ${classbtVerde}`} onFocus={handleInputFocus} onClick={handleAddContaListClick}>
                                        <FaPlus className={`w-3 h-3`} />
                                    </button>
                                </div>

                                <div className={`relative col-span-12 mt-1`}>

                                    <div className={`w-full`}>
                                        <ul className={`w-full h-full dark:bg-slate-500 text-slate-700 dark:text-white`}>
                                            <li className={`h-10`}>
                                                <div className={`w-full flex flex-row h-10 text-sm`}>

                                                    <div className={`flex items-center justify-start w-[60%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Conta</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-[30%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Valor</span>
                                                    </div>

                                                    <div className={`flex items-center justify-center w-[10%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>[X]</span>
                                                    </div>

                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className={`overflow-auto h-full max-h-[1000px] scrollbar-custom dark:scrollbar-custom-dark`}>

                                        <div className={`w-full`}>

                                            <ul className={`w-full`}>
                                                {lanctoContasList.length > 0 &&
                                                    lanctoContasList.map((item) => (
                                                        <li key={item.id_conta} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>

                                                            <div className={`w-full flex flex-row h-[40px] text-sm break-all text-black dark:text-slate-200`}>

                                                                <div className={`flex items-center justify-start w-[60%] border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{item.description}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[30%] border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-center w-[10%] border border-slate-300 dark:border-slate-700`}>
                                                                    <button className={`flex items-center justify-center w-6 h-6 rounded-sm text-white transition-all duration-150 ${classbtVermelho}`}
                                                                        onClick={() => handleRemoveContaListClick(item)}>
                                                                        <FaTrashAlt className="w-3 h-3" />
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[60px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button disabled={loading} onClick={fecharModal}
                        className={`${classbtColunasVermelho} max-w-[150px]`} >
                        CANCELAR
                    </button>

                    <button disabled={loading} onClick={handleLiquidarCartao}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? 'BAIXAR' : 'AGUARDE'}
                    </button>

                </div>

            </div>

        </div>
    )
})